module.exports = __webpack_public_path__ + "static/media/phone-icon.9bbe4e51.png";